import { LocationTypes } from '../locationTypes';

export const getClassNameFromTheme = (
  theme: LocationTypes.TTheme | undefined
) => {
  if (theme && theme === 'dark') {
    return 'has-text-white';
  }
  return 'has-text-black';
};
export const getIconColorFromTheme = (
  theme: LocationTypes.TTheme | undefined
) => {
  if (theme && theme === 'dark') {
    return 'white';
  }
  return 'black';
};
